<template>
    <div class="dayDeal">
        <NoData v-if="dayDeal.length<=0" :isTrade="isTrade"></NoData>
        <ul v-else>
            <li v-for="item in dayDeal">
                <div class="itemTit">
                    <div class="leftCon"><span>{{item.SName.szShortName}}</span><p>#{{item.ID}}</p></div>
                    <div class="rightCon"><div class="item"><time>{{item.ExecuteTime|time}}</time></div></div>
                </div>
                <div class="itemCon">
                    <div class="leftCon">
                        <div class="itemList">
                            <div class="item"><em :class="cutover(item.DirectionStr)">{{item.DirectionStr}}</em><p>{{item.ExecuteVolume}}</p></div>
                            <div class="item"><p>{{tradeUtil.DealReason[item.Reason]}}</p></div>
                            <div class="item"><span>{{$t('trade.products.finalPrice')}}</span><p>{{item.ExecutePrice}}</p></div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
    import moment from 'moment'
    import {mapState} from 'vuex'
    import Util from '@/utils/tradeDataUtil'
    import TradeUtil from '@/utils/tradeUtil'
    import NoData from '@/view/module/NoData.vue'
    export default {
        name: "DayDeal",
        filters: {
            time(longTime) {
                return moment(new Date(longTime*1000)).format("YYYY-MM-DD HH:mm:ss");
            }
        },
        components:{NoData},
        computed: {
            ...mapState(['tradeData', 'quote']),
            dayDeal:{
                get(){
                    return this.tradeData.dayDeal;
                }
            }
        },
        data(){
            return {
                util:Util,
                tradeUtil:TradeUtil,
                isTrade:true
            }
        },
        methods:{
            cutover:function(obj){
                let val;
                if (obj==this.$t('trade.products.openingBuy')){
                    val="buy"
                }else if(obj==this.$t('trade.products.openingSell')){
                    val="sell"
                }else if(obj==this.$t('trade.products.executeBuy')){
                    val="sell"
                }else if(obj==this.$t('trade.products.executeSell')){
                    val="buy"
                }
                return val;
            },
        },
    }
</script>
